import Intercom, { hide, show } from "@intercom/messenger-js-sdk";
import { useEffect } from "react";

import { INTERCOM_APP_ID } from "@/config";
import { getUser } from "@/modules/auth/service";

export const showCustomerService = () => {
  show();
};

export const hideCustomerService = () => {
  hide();
};

export const useCustomerService = () => {
  const handleOutsideClick = (event) => {
    const intercomFrame = document.querySelector("#intercom-container");
    if (intercomFrame && !intercomFrame.contains(event.target)) {
      hide();
    }
  };

  useEffect(() => {
    getUser().then(({ user }) => {
      if (!user) return;

      Intercom({
        app_id: INTERCOM_APP_ID,
        user_id: user.id,
        name: user.user_metadata.displayName,
        email: user.email,
        created_at: user.created_at,
        hide_default_launcher: true,
      });

      window.Intercom("onShow", () => {
        document.addEventListener("click", handleOutsideClick);
      });

      window.Intercom("onHide", () => {
        document.removeEventListener("click", handleOutsideClick);
      });
    });

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
};
